import React from "react";
import useStyles from "./Styles";
import { Box, Typography, Grid } from "@material-ui/core";
import sidebarCollapse from "../../assets/sidebar-hide.png";
import userActions from "./actions";

const ChartDrawer = (props) => {
  const classes = useStyles();
  const { onClose } = props;
  const { setChart } = userActions();
  return (
    <Box className={classes.chartDrawer}>
      <Grid container item>
        <Grid
          item
          xs={12}
          className={classes.chartItem}
          style={{
            height: 90,
            background: "transparent",
            marginBottom: 0,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            component="div"
            className={classes.chooseText}
          >
            Choose Chart
          </Typography>
          <img
            src={sidebarCollapse}
            className={classes.chartToggleIcon}
            style={{ paddingRight: 32 }}
            onClick={onClose}
            alt="toggle-icon.png"
          />
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.chartItem}
          onClick={() => setChart("central_arizona_shortage_impacts")}
        >
          <Typography
            variant="h6"
            component="div"
            className={classes.chartItemTitle}
          >
            Central Arizona Shortage Impacts
          </Typography>
          {/* <Typography
            variant="body2"
            component="p"
            className={classes.chartItemDesc}
          >
            Explanation about what this means and what the narrative measures on
            the base level.
          </Typography> */}
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.chartItem}
          onClick={() => setChart("allocations")}
        >
          <Typography
            variant="h6"
            component="div"
            className={classes.chartItemTitle}
          >
            Allocations
          </Typography>
          {/* <Typography
            variant="body2"
            component="p"
            className={classes.chartItemDesc}
          >
            Explanation about what this means and what the narrative measures on
            the base level.
          </Typography> */}
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.chartItem}
          onClick={() => setChart("shortage_impacts_by_community")}
        >
          <Typography
            variant="h6"
            component="div"
            className={classes.chartItemTitle}
          >
            Shortage Impacts by Community
          </Typography>
          {/* <Typography
            variant="body2"
            component="p"
            className={classes.chartItemDesc}
          >
            Explanation about what this means and what the narrative measures on
            the base level.
          </Typography> */}
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.chartItem}
          onClick={() => setChart("shortage_impacts_by_sector")}
        >
          <Typography
            variant="h6"
            component="div"
            className={classes.chartItemTitle}
          >
            Shortage Impacts by Sector
          </Typography>
          {/* <Typography
            variant="body2"
            component="p"
            className={classes.chartItemDesc}
          >
            Explanation about what this means and what the narrative measures on
            the base level.
          </Typography> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChartDrawer;
